@if (kontraktId$ | async; as kontraktId) {
  <rask-toggle-panel
    label="Värdeberäkning"
    [defaultExpanded]="false">
    @for (vardeberakning of vardeberakning$ | async; track $index; let i = $index) {
      @if (vardeberakning.virkesvarde.rader.length) {
        <div class="mb-4">
          <table class="simple-table">
            <caption class="m-0 p-0">
              <h4 class="m-0">Virkesvärde</h4>
            </caption>
            <thead>
              <tr>
                <th>HS</th>
                <th>m3fub</th>
                <th>Grundpris</th>
                <th>Totalt</th>
              </tr>
            </thead>
            <tbody>
              @for (row of vardeberakning.virkesvarde.rader; track $index) {
                <tr>
                  @if (row.handelssortimentId) {
                    <td>
                      {{row.handelssortimentNamn }}
                    </td>
                  } @else {
                    <td class="fw-bold">
                      {{row.handelssortimentsgruppNamn }}
                    </td>
                  }
                  <td> {{row.m3Fub | number: '1.0-0'}} </td>
                  <td> {{row.grundpris | number: '1.0-0'}} </td>
                  <td> {{row.totaltKr | number: '1.0-0'}} </td>
                </tr>
              }
            </tbody>
            @if (vardeberakning.virkesvarde.summa; as summa) {
              <tfoot>
                <tr>
                  <td>Summa</td>
                  <td> {{summa.m3Fub | number: '1.0-0'}} </td>
                  <td> {{summa.grundpris | number: '1.0-0'}} </td>
                  <td> {{summa.totaltKr | number: '1.0-0'}} </td>
                </tr>
              </tfoot>
            }
          </table>
        </div>
      }
      @if (vardeberakning.avverkningskostnad.rader.length) {
        <div class="mb-4">
          <table class="simple-table">
            <caption class="m-0 p-0">
              <h4 class="m-0">Avverkningskostnad</h4>
            </caption>
            <thead>
              <tr>
                <th>Avverkningskostnad</th>
                <th>kr per m3f</th>
                <th>kr</th>
              </tr>
            </thead>
            <tbody>
              @for (row of vardeberakning.avverkningskostnad.rader; track $index) {
                <tr>
                  <td> {{row.typ }} </td>
                  <td> {{row.krPerM3Fub | number: '1.0-0' }} </td>
                  <td> {{row.totaltKr | number: '1.0-0' }} </td>
                </tr>
              }
            </tbody>
            @if (vardeberakning.avverkningskostnad.summa; as summa) {
              <tfoot>
                <tr>
                  <td>Summa</td>
                  <td> {{summa.krPerM3Fub | number: '1.0-0' }} </td>
                  <td> {{summa.totaltKr | number: '1.0-0' }} </td>
                </tr>
              </tfoot>
            }
          </table>
        </div>
      }
      @if (vardeberakning.sortimentSnittnetto.rader.length) {
        <div>
          <table class="simple-table">
            <caption class="m-0 p-0">
              <h4 class="m-0">Sortiment- och snittnetto</h4>
            </caption>
            <thead>
              <tr>
                <th>HS</th>
                <th>Rotvärde</th>
                <th>TA</th>
                <th>FSC</th>
                <th>PEFC</th>
                <th>Sortimentsnetto</th>
                <th>Totalt</th>
              </tr>
            </thead>
            <tbody>
              @for (row of vardeberakning.sortimentSnittnetto.rader; track $index) {
                <tr>
                  @if (row.handelssortimentId) {
                    <td>
                      {{row.handelssortimentNamn }}
                    </td>
                  } @else {
                    <td class="fw-bold">
                      {{row.handelssortimentsgruppNamn }}
                    </td>
                  }
                  <td>{{row.rotvarde | number: '1.0-0'}}</td>
                  <td>{{row.tillaggAvdrag | number: '1.0-0'}}</td>
                  <td>{{row.fsc | number: '1.0-0'}}</td>
                  <td>{{row.pefc | number: '1.0-0'}}</td>
                  <td>{{row.kopeskilling | number: '1.0-0'}}</td>
                  <td>{{row.totalt | number: '1.0-0'}}</td>
                </tr>
              }
            </tbody>
            <tfoot>
              @if (vardeberakning.sortimentSnittnetto.summa; as summa) {
                <tr>
                  <td>Summa</td>
                  <td>{{summa.rotvarde | number: '1.0-0'}}</td>
                  <td>{{summa.tillaggAvdrag | number: '1.0-0'}}</td>
                  <td>{{summa.fsc | number: '1.0-0'}}</td>
                  <td>{{summa.pefc | number: '1.0-0'}}</td>
                  <td>{{summa.kopeskilling | number: '1.0-0'}}</td>
                  <td>{{summa.totalt | number: '1.0-0'}}</td>
                </tr>
              }
            </tfoot>
          </table>
        </div>
      }
    }
    <rask-row>
      <a href="javascript:void(0)" (click)="openDokument(kontraktId)" class="btn-link">Visa PDF</a>
      <a href="javascript:void(0)" (click)="downloadDokument(kontraktId)" class="btn-link ms-2">Hämta PDF</a>
    </rask-row>
  </rask-toggle-panel>
}